import React, { useEffect, useState } from 'react';
import { apiGet, apiPost, apiDelete } from './config/apiClient';
import { t } from './i18n';

export default function PlaceTagsEditor({ venueId, venueName, onClose, onTagsChange }) {
  const [tags, setTags] = useState([]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    apiGet(`/api/places/${encodeURIComponent(venueId)}/tags`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        setTags(data.tags || []);
        setLoading(false);
      })
      .catch(() => {
        if (cancelled) return;
        setError(t('web.tags.loadFail'));
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [venueId]);

  const addTag = () => {
    const tag = input.trim();
    if (!tag) return;
    apiPost(`/api/places/${encodeURIComponent(venueId)}/tags`, { tag })
      .then((res) => res.json())
      .then((data) => {
        setTags(data.tags || []);
        setInput('');
        if (onTagsChange) onTagsChange(data.tags || []);
      })
      .catch(() => setError(t('web.tags.addFail')));
  };

  const removeTag = (tag) => {
    apiDelete(`/api/places/${encodeURIComponent(venueId)}/tags/${encodeURIComponent(tag)}`)
      .then((res) => res.json())
      .then((data) => {
        setTags(data.tags || []);
        if (onTagsChange) onTagsChange(data.tags || []);
      })
      .catch(() => setError(t('web.tags.removeFail')));
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      addTag();
    }
  };

  return (
    <div className="place-tags-overlay" onClick={onClose}>
      <div className="place-tags-content glass-panel" onClick={(e) => e.stopPropagation()}>
        <div className="place-tags-header">
          <h4>Tags · {venueName || 'Local'}</h4>
          <button type="button" className="place-tags-close" onClick={onClose} aria-label={t('action.close')}>×</button>
        </div>

        {error && <p className="place-tags-error">{error}</p>}

        {loading ? (
          <p>Carregando...</p>
        ) : (
          <ul className="place-tags-chip-list">
            {tags.map((tag) => (
              <li key={tag} className="place-tags-chip">
                <span>{tag}</span>
                <button type="button" onClick={() => removeTag(tag)} aria-label={t('web.tags.remove.a11y', { tag })}>×</button>
              </li>
            ))}
            {tags.length === 0 && <li className="place-tags-empty">Nenhuma tag ainda.</li>}
          </ul>
        )}

        <div className="place-tags-input-row">
          <input
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder="Nova tag (Enter para adicionar)"
          />
          <button type="button" onClick={addTag}>Adicionar</button>
        </div>
      </div>
    </div>
  );
}
